export default __webpack_public_path__ + "static/poster-4-b5a761a1b722954bcf7177562cfb59f9.webm";